"use client";

import { useState } from "react";
import { useJsonResource } from "@/hooks/useJsonResource";
import type { PaletteWorker } from "@/lib/commandPalette";

/** The worker and knowledge-base lists the palette searches over. */
export function usePaletteData(isOpen: boolean) {
  const [workers, setWorkers] = useState<PaletteWorker[]>([]);

  // Both lists load afresh each time the palette opens. The worker list is
  // local state because the bulk toggle updates it optimistically.
  useJsonResource<{ workers?: PaletteWorker[] }>(isOpen ? "/api/workers" : null, {
    onData: (data) => setWorkers(data.workers ?? []),
  });
  const { data: kbData, loading: loadingKb } = useJsonResource<{
    pages?: string[];
  }>(isOpen ? "/api/kb" : null);
  const kbPages = kbData?.pages ?? [];

  return { workers, setWorkers, kbPages, loadingKb };
}
